export const isLowerCase = char => /[a-z]{1}/.test(char);
